export const EXPERIENCE = [
  {
    company: 'NIIT',
    role: 'Senior Faculty & Software Engineer',
    period: 'May, 2021',
    logo: '',
    jobInfo:
      'Facilitate training for young leaders on in-demand programming languages and software development life cycle. Introduced project-based learning and  evaluation that increased student engagement, participation and learning outcome by 40%',
  },
  {
    company: 'ICTG',
    role: 'Fullstack Software Engineer',
    period: 'May, 2018 - May, 2021',
    logo: '',
    jobInfo:
      'Design and build RESTful APIs in Nodejs and user-facing Reactjs app that enabled internal team to increase program onboarding, accreditation and reporting speed by 24%',
  },
  {
    company: 'Raenest',
    role: 'Frontend Software Engineer',
    period: 'June, 2021 - March, 2022',
    logo: '',
    jobInfo:
      'Build frontend of customer-facing app from codebase setup to MVP and beyond. Collaborated with an agile team of 6, providing feedback to backend developers, identify bugs which improved application data management and site performance',
  },
  {
    company: 'Lightworth Computing',
    role: 'Web Developer',
    period: ' Dec, 2016 - May, 2018',
    logo: '',
    jobInfo:
      'Collaborated with stakeholders and project owners to identify features and architect web app for early stage startups',
  },
];

export const EDUCATION = [
  {
    school: 'COURSERA',
    course: 'Google Data Analytics',
    period: 'May, 2022',
    logo: '',
    description: '',
  },
  {
    school: 'UTIVA',
    course: 'Data Analytics Program: Accelerator(SQL & PowerBI)',
    period: 'June, 2021',
    logo: '',
    description: '',
  },
  {
    school: 'COURSERA',
    course: 'Google IT Automation with Python',
    period: 'May, 2021',
    logo: '',
    description: '',
  },
  {
    school: 'COURSERA',
    course: 'Google IT Support Professional  Certification',
    period: 'April, 2021',
    logo: '',
    description: '',
  },
  {
    school: 'LINKEDIN LEARNING',
    course: 'Software Developer Professional Certification',
    period: 'Sept, 2020',
    logo: '',
    description: '',
  },
  {
    school: 'UDEMY',
    course: 'MERN Stack Front To Back: Full Stack React, Redux & Node.js',
    period: 'May, 2019',
    logo: '',
    description: '',
  },
  {
    school: 'HIIT',
    course: 'Certificate in Web',
    period: 'Jan., 2017',
    logo: '',
    description: '',
  },
  {
    school: 'Federal University of Technology',
    course: 'Petroleum Engineering(First Class Honors)',
    period: 'Dec., 2016',
    logo: '',
    description: '',
  },
];

export const SKILLS = [
  {
    label: 'JavaScript',
  },
  {
    label: 'JavaScript',
  },
  {
    label: 'Python',
  },
  {
    label: 'SQL',
  },
  {
    label: 'Reactjs/Nextjs',
  },
  {
    label: 'Nodejs(Expressjs)',
  },
  {
    label: 'Styled Components',
  },
  {
    label: 'MongoDB',
  },
  {
    label: 'Git/Github',
  },
  {
    label: 'AWS',
  },
  {
    label: 'CircleCI',
  },
  {
    label: 'CloudFormation',
  },
];
